import React from 'react';
import { motion } from 'framer-motion';
const achievements = [{
  icon: '🃏',
  title: 'Interpretar las 78 cartas'
}, {
  icon: '📖',
  title: 'Comprender los Arcanos Mayores'
}, {
  icon: '✨',
  title: 'Dominar los Arcanos Menores'
}, {
  icon: '🔮',
  title: 'Realizar tiradas profesionales'
}, {
  icon: '❤️',
  title: 'Desarrollar la intuición'
}, {
  icon: '💼',
  title: 'Realizar consultas con seguridad'
}];
export function Achievements() {
  return <section className="py-20 relative z-10 bg-mystic-900/50" data-id="element-49">
      <div className="container mx-auto px-4" data-id="element-50">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-51">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-52">
            ¿Qué vas a lograr con esta formación?
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-53"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-54">
          {achievements.map((item, i) => <motion.div key={i} initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-mystic-800 border border-mystic-700 hover:border-gold/50 p-6 rounded-2xl transition-colors group" data-id="element-55">
              <div className="text-4xl mb-4 transform group-hover:scale-110 transition-transform origin-left" data-id="element-56">
                {item.icon}
              </div>
              <h3 className="text-lg font-semibold text-white/90" data-id="element-57">
                {item.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}